'use client';

import { useState, useEffect } from 'react';
import { useAuth } from '../session-auth/hooks/useAuth';
import { checkUserExistsByEmailAction, getUserIdByEmailAction } from '@/app/user-and-session/user-app-data/server/user-id/UserIDAndExist';

interface OnboardingStatus {
  isLoading: boolean;
  showOnboarding: boolean;
  actualUserId: string | null;
  isOnboarded: boolean;
}

export function useOnboardingStatus(): OnboardingStatus {
  const { isAuthenticated, userEmail, isOnboarded: tokenIsOnboarded, tempPreferredName } = useAuth();
  const [status, setStatus] = useState<OnboardingStatus>({
    isLoading: true,
    showOnboarding: false,
    actualUserId: null,
    isOnboarded: false
  });

  useEffect(() => {
    async function checkOnboardingStatus() {
      console.log("checkOnboardingStatus", isAuthenticated, userEmail);
      if (!isAuthenticated || !userEmail) {
        setStatus({
          isLoading: false,
          showOnboarding: false,
          actualUserId: null,
          isOnboarded: false
        });
        return;
      }

      try {
        // Check if user exists in database
        const userExists = await checkUserExistsByEmailAction(userEmail);
        console.log("checkOnboarding userExists in db", userExists);
        if (userExists) {
          // User completed onboarding, get their permanent ID
          const permanentUserId = await getUserIdByEmailAction(userEmail);
          setStatus({
            isLoading: false,
            showOnboarding: false,
            actualUserId: permanentUserId,
            isOnboarded: true
          });
        } else {
          // User needs to complete onboarding
          setStatus({
            isLoading: false,
            showOnboarding: true,
            actualUserId: null,
            isOnboarded: false
          });
        }
      } catch (error) {
        console.error('Error checking onboarding status:', error);
        // Default to showing onboarding if we can't check
        setStatus({
          isLoading: false,
          showOnboarding: true,
          actualUserId: null,
          isOnboarded: false
        });
      }
    }

    checkOnboardingStatus();
  }, [isAuthenticated, userEmail, tokenIsOnboarded]);

  return status;
}
